/*
  Mad Olive - product main image desktop navigation.

  The Expanse product gallery (snippets/product.gallery.liquid + assets/product.gallery.js)
  runs the main product image as a Flickity carousel, but ships with the prev/next
  buttons turned off and hides the page dots above 768px. So on desktop the only way to
  move between photos was the thumbnail strip or dragging - there was no visible control
  on the main image itself.

  This add-on, loaded from layout/theme.liquid, does two things on desktop only:
    1. Injects matching prev/next arrows over the main image.
    2. Reveals the carousel page dots under the main image.
  Mobile keeps its native full-bleed swipe + dots untouched.

  The arrows drive the theme's own gallery by triggering the matching thumbnail link,
  which is exactly what the theme wires to the Flickity slideshow (assets/module.slideshow.js).
  That keeps the slide, the active thumbnail and the page dots in sync, with no changes
  to the theme's gallery code.
*/
(function () {
  var CSS = `
    @media only screen and (min-width: 769px) {
      .mo-gallery-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        padding: 0;
        border: 1px solid color-mix(in srgb, var(--root-color-primary, #1c1d1d) 12%, transparent);
        border-radius: 50%;
        background: color-mix(in srgb, var(--root-color-secondary, #fff) 85%, transparent);
        color: var(--root-color-primary, #1c1d1d);
        cursor: pointer;
        opacity: 0.85;
        transition: opacity 0.2s ease, background-color 0.2s ease;
        -webkit-appearance: none;
        appearance: none;
      }
      .product__main-photos:hover .mo-gallery-arrow,
      .mo-gallery-arrow:focus-visible { opacity: 1; }
      .mo-gallery-arrow:hover { background: var(--root-color-secondary, #fff); }
      .mo-gallery-arrow--prev { left: 14px; }
      .mo-gallery-arrow--next { right: 14px; }
      .mo-gallery-arrow::before {
        content: '';
        display: block;
        width: 9px;
        height: 9px;
        border-top: 2px solid currentColor;
        border-right: 2px solid currentColor;
      }
      .mo-gallery-arrow--prev::before { transform: rotate(-135deg); margin-left: 4px; }
      .mo-gallery-arrow--next::before { transform: rotate(45deg); margin-right: 4px; }

      .product__main-photos .flickity-page-dots {
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 14px;
        z-index: 3;
        width: 100%;
        margin: 0;
        padding: 0;
        text-align: center;
        line-height: 1;
      }
      .product__main-photos .flickity-page-dots .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        margin: 0 5px;
        border: 0;
        border-radius: 50%;
        background: var(--root-color-secondary, #fff);
        box-shadow: 0 0 0 1px color-mix(in srgb, var(--root-color-primary, #1c1d1d) 35%, transparent);
        opacity: 0.7;
        cursor: pointer;
      }
      .product__main-photos .flickity-page-dots .dot.is-selected {
        background: var(--root-color-primary, #1c1d1d);
        box-shadow: 0 0 0 1px color-mix(in srgb, var(--root-color-secondary, #fff) 55%, transparent);
        opacity: 1;
      }
    }
    @media only screen and (max-width: 768px) {
      .mo-gallery-arrow { display: none; }
    }
  `;

  function injectStyles() {
    if (document.getElementById('mo-gallery-nav-styles')) return;
    var style = document.createElement('style');
    style.id = 'mo-gallery-nav-styles';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function currentIndex(thumbs) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function makeArrow(modifier, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mo-gallery-arrow ' + modifier;
    btn.setAttribute('aria-label', label);
    return btn;
  }

  function initGallery(root) {
    var main = root.querySelector('.product__main-photos');
    if (!main) return;
    if (main.querySelector('.mo-gallery-arrow')) return;

    var thumbs = root.querySelectorAll('[data-product-thumbs] a[data-product-thumb]');
    if (thumbs.length < 2) return;

    var prev = makeArrow('mo-gallery-arrow--prev', 'Previous image');
    var next = makeArrow('mo-gallery-arrow--next', 'Next image');

    function go(direction) {
      var n = thumbs.length;
      var idx = (currentIndex(thumbs) + direction + n) % n;
      thumbs[idx].click();
    }

    prev.addEventListener('click', function (e) {
      e.preventDefault();
      go(-1);
    });
    next.addEventListener('click', function (e) {
      e.preventDefault();
      go(1);
    });

    main.appendChild(prev);
    main.appendChild(next);
  }

  function initAll() {
    injectStyles();
    var galleries = document.querySelectorAll('product-images');
    for (var i = 0; i < galleries.length; i++) {
      initGallery(galleries[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
